import { Button } from '../ui/button';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

interface DeleteDraftDappDialogProps {
  dappName: string;
  isOpen: boolean;
  isDeleting: boolean;
  onClose: () => void;
  onDelete: () => void | Promise<void>;
}

export function DeleteDraftDappDialog({
  dappName,
  isOpen,
  isDeleting,
  onClose,
  onDelete,
}: DeleteDraftDappDialogProps) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open && !isDeleting) onClose();
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Delete draft app?</DialogTitle>
          <DialogDescription>
            This removes <span className="font-medium">{dappName}</span> and its
            draft releases from the portal. Published apps cannot be deleted.
          </DialogDescription>
        </DialogHeader>

        <DialogBody>
          <div className="rounded-lg border border-red-500/20 bg-red-500/10 p-3 text-sm text-red-100">
            This is a soft delete. Contact support if you need the draft
            restored.
          </div>
        </DialogBody>

        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onDelete}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete draft app'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
